import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import "../../../assets/css/dashboard.css";
import { useNavigate } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import { OverlayPanel } from "primereact/overlaypanel";
import { useSelector, useDispatch } from "react-redux";
import { persistStore } from "redux-persist";
import { store } from "../../../store/store";
import { LOGOUT, PROJECT_PANEL } from "../../../utils/constants";
import { useGlobalContext } from "../../../context/GlobalContext";
import ChangePasswordModal from "../../ChangePasswordModal/ChangePasswordModal";

const AdminHeader = ({
  handleShowSidebar,
  showSidebar,
  setSelectedPanelProject,
  selectePanelProject,
  subHeaderText,
  clientName,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const op = useRef(null);
  const { clearContext } = useGlobalContext();
  const [showChangePwdModal, setShowChangePwdModal] = useState(false);

  const handleButtonClick = (buttonLabel) => {
    if (buttonLabel === "DASHBOARD") {
      navigate("/dashboard");
    } else if (buttonLabel === "REPORTS") {
      navigate("/reports");
    }
  };

  const handleDropdownClick = (option) => {
    if (option.value === "logout") {
      logout();
    } else {
      navigate(`/${option.value}`);
    }
  };

  const logout = () => {
    dispatch({ type: LOGOUT });
    clearContext();
    // Clear Redux Persist store
    persistStore(store)
      .purge()
      .then(() => {
        // Clear localStorage
        localStorage.clear();

        // Clear sessionStorage
        sessionStorage.clear();

        // Clear all cookies (this removes all cookies for the current domain)
        document.cookie.split(";").forEach((cookie) => {
          const eqPos = cookie.indexOf("=");
          const name =
            eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          // Set cookie expiry to past date to delete it
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });

        // Redirect to login page after logout
        navigate("/login");
      });
  };

  return (
    <>
      {/* Top Header */}
      <div
        className={`d-flex align-items-center p-3 border-bottom position-fixed top-header justify-content-between ${!showSidebar ? "hide-sidebar" : ""}`}
      >
        <div className="text-start d-flex align-items-center justify-content-center">
          {/* <div className="text-start d-flex align-items-center gap-2">
            <span className="fw-bold text-dark" style={{ fontSize: "18px" }}>
              UseSights
            </span>
          </div> */}
          <div
            className="text-start hide-sidebar-icon d-flex align-items-center justify-content-center"
            onClick={handleShowSidebar}
          >
            <i
              className={`pi ${!showSidebar ? "pi-angle-right" : "pi-angle-left"}`}
            ></i>
          </div>
          <p
            className="mb-0 text-start ps-2 fw-600 text-capitalize"
            style={{ color: "#002133" }}
          >
            {clientName}
          </p>
        </div>

        <div className="d-flex align-items-center gap-2" id="logout_section">
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            Welcome {user && user.firstname ? user.firstname : "User"}
          </span>

          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={(e) => op.current.toggle(e)}
          >
            <Avatar
              icon="pi pi-user"
              shape="circle"
              style={{
                backgroundColor: "#9c27b0",
                color: "#ffffff",
                cursor: "pointer",
              }}
            />
            <i className="pi pi-chevron-down ms-1 fs-12 fw-600"></i>
          </div>

          <OverlayPanel ref={op} className="custom-overlay-panel">
            <div
              className="p-2"
              onClick={() => setShowChangePwdModal(!showChangePwdModal)}
              style={{ cursor: "pointer" }}
            >
              Change Password
            </div>
            <div className="p-2" onClick={logout} style={{ cursor: "pointer" }}>
              Logout
            </div>
          </OverlayPanel>
        </div>
      </div>

      {/* Second Header */}
      <div
        style={{ marginTop: "65px", backgroundColor: "#fff" }}
        className={`d-flex flex-column flex-md-row py-2 border-bottom w-100 ${!showSidebar ? "hide-sidebar" : ""}`}
      >
        <div className="flex-grow-1 ms-3 text-start flex-wrap mb-2 mb-md-0">
          <Button
            outlined
            className={`me-md-3 ${
              location.pathname === "/dashboard" ? "active-button" : ""
            } br-c`}
            label={
              window.location.pathname.includes("/admin-panel/survey")
                ? "Custom XMOTs"
                : window.location.pathname.includes(
                      "/admin-panel/other-activities",
                    )
                  ? "Other Activities"
                  : subHeaderText
                    ? subHeaderText
                    : "Dashboard"
            }
            style={{
              cursor: "default",
              fontSize: "16px",
              padding: "0.5rem 0rem",
              fontWeight: "100",
            }}
          />
        </div>
      </div>

      {showChangePwdModal ? (
        <ChangePasswordModal
          showChangePwdModal={showChangePwdModal}
          setShowChangePwdModal={setShowChangePwdModal}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AdminHeader;
